import React from 'react'
import {TagsProps} from './types'
import TagsView from './TagsView'
import {mapTags} from '../../utils/MapTags'
import {useTags} from '../../hooks/ninchat'

const Tags = (props: TagsProps): React.ReactElement => {
    const {
        realmId,
        tagIds,
    } = props

    const tags = useTags(realmId)

    const [filteredTags, setFilteredTags] = React.useState({})

    React.useEffect(() => {
        const filtered = mapTags({
            tagIds,
            tags,
        })

        setFilteredTags(filtered)
    }, [tags, tagIds])

    return <TagsView tags={filteredTags} />
}

export default Tags
